export { SortIconComponent } from "./sort-icon.component";
export { SortIconComponentModule } from "./sort-icon-component.module";
